export const ACCOUNT_PROFILE = 'account.profile';

const ProfileLabels = {
  account: {
    profile: {
      lbl_add_child_save: 'Save',
      lbl_add_child_faq: 'Frequently Asked Questions',
      lbl_add_child_privacy: 'Privacy',
      lbl_add_child_terms_agreement_second:
        'and (2) consenting to register yourself and the child(ren) listed above into the Birthday Savings.',
      // eslint-disable-next-line no-useless-escape
      lbl_add_child_terms_agreement: `By entering your name and pressing \"Add A Child,\" you are signing this record and verifying that you are (1) the parent or legal guardian of the child(ren) listed above,`,
      lbl_add_child_timestamp: 'Timestamp',
      lbl_add_child_parent_digital_signature: 'Parent’s Digital Signature',
      lbl_add_child_choose_gender: 'Choose Gender',
      lbl_add_child_gender_heading: "Child's Gender",
      lbl_add_child_birthday_year: 'Year',
      lbl_add_child_birthday_month: 'Month',
      lbl_add_child_birthday_heading: "Child's Birthday",
      lbl_add_child_child_name: "Child's Name",
      lbl_add_child_child_information: 'Child’s Information',
    },
  },
};

export default ProfileLabels;
